// Imports
import React from "react"
import { useSectionAudiancesData } from "@queries"
import { AudiancesCardSection } from "./audiances-card"
import { Section } from "@layout"

export const Audiances = () => {
  const { title, audiancesCards } = useSectionAudiancesData()
  return (
    <Section name="audiances" backgroundColor='#350B56'>
      <div className="audiances-container">
        <h1> {title} </h1>
      </div>
      <AudiancesCardSection displayData={audiancesCards} />
    </Section>
  )
}
